/* ═══════════════════════════════════════════════════════════════════════
   RT BACK-TO-TOP — scroll-progress driver  v3 (live + smooth)  15 Jul 2026
   Upload as an asset, then load it deferred from theme.liquid (see INSTALL).
   ------------------------------------------------------------------------
   Sets --rtp (0–100 = scroll percentage) on #totop; the conic-gradient ring
   in custom.css reads it.

   Why the smoothing is here and NOT a CSS transition:
     A CSS transition on --rtp makes the browser defer the ring's repaint
     during active scrolling, so it only updates when scroll STOPS. Instead
     we interpolate toward the target ourselves every animation frame and
     write --rtp directly — that paints live while scrolling AND eases.

   Light by design:
     • page height is measured once and cached (re-measured only on real
       resize/reflow via ResizeObserver) — reading it per frame is what
       caused the original stutter.
     • the rAF loop runs only while the ring still has distance to travel,
       then stops itself. Idle = zero work.
   ═══════════════════════════════════════════════════════════════════════ */
(function () {
  var totop = document.getElementById('totop');
  if (!totop) return;

  var max = 0;        /* cached max scroll distance */
  var target = 0;     /* where the ring should be   */
  var current = 0;    /* where the ring is now      */
  var raf = null;

  function measure() {
    var el = document.documentElement;
    max = el.scrollHeight - el.clientHeight;
  }

  function readTarget() {
    target = max > 0 ? (window.scrollY / max) * 100 : 0;
    if (target < 0) target = 0;
    else if (target > 100) target = 100;
  }

  function tick() {
    current += (target - current) * 0.18;          /* ease toward target */
    if (Math.abs(target - current) < 0.1) current = target;
    totop.style.setProperty('--rtp', current.toFixed(1));
    raf = (current === target) ? null : requestAnimationFrame(tick);
  }

  function kick() {
    if (raf === null) raf = requestAnimationFrame(tick);
  }

  function onScroll() { readTarget(); kick(); }

  measure();
  readTarget();
  current = target;
  totop.style.setProperty('--rtp', current.toFixed(1));

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { measure(); onScroll(); }, { passive: true });
  window.addEventListener('load', function () { measure(); onScroll(); });

  if (window.ResizeObserver) {
    new ResizeObserver(function () { measure(); }).observe(document.body);
  }
})();